import {
    SET_LOADING,
    GET_FILTERS,
    SET_FILTER,
    GET_FILTERS_ERROR,
    SET_FILTER_ERROR,

} from '../actions/actions.js'
import {
    CLEAR_PREVIOUS_FILTER, DELETE_FILTER,
    DELETE_PREVIOUS_FILTER,
    DELETE_PREVIOUS_FILTER_ERROR,
    SET_PREVIOUS_FILTER,
    SET_PREVIOUS_FILTER_ERROR, REFRESH_FILTERS,
    CLEAR_FILTERS, SET_START_DATE, SET_END_DATE, CLEAR_BASIC_FILTER, GET_OPK_FILTERS, GET_OPK_FILTERS_ERROR,
    DELETE_ALL_PREVIOUS_SUBFILTERS,DELETE_ALL_PREVIOUS_SUBFILTERS_ERROR
} from "../actions/actions";
import * as moment from "moment";

const initialState = {
    available_filters: [],
    active_filter: [],
    previous_filter: {},
    refresh_filter: false,
    start_date: moment("2021-01-01"),
    end_date: moment("2021-12-31"),
    opk_filters: []
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_FILTERS:
            return {
                ...state,
                available_filters: action.payload,

            };
        case SET_FILTER:
            return {
                ...state,
                active_filter: [...state.active_filter, action.payload],
            };

        case GET_FILTERS_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case SET_FILTER_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case SET_PREVIOUS_FILTER:
            return {
                ...state,
                previous_filter: {
                    ...state.previous_filter,
                    [action.payload.filterName]: {...state.previous_filter[action.payload.filterName], ...action.payload.filterValue}
                },
            };
        case SET_PREVIOUS_FILTER_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case DELETE_PREVIOUS_FILTER:
                let deletePreviousFilters = {...state.previous_filter[action.payload.filterName]}
                delete deletePreviousFilters[Object.keys(action.payload.filterValue)[0]]
                return {
                    ...state,
                    previous_filter: {...state.previous_filter, [action.payload.filterName]: {...deletePreviousFilters}}
                };

        case
        DELETE_PREVIOUS_FILTER_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
         case DELETE_ALL_PREVIOUS_SUBFILTERS:
                let deletePreviousFilters2 = {...state.previous_filter}
                delete deletePreviousFilters2[action.payload.filterName]
                return {
                    ...state,
                    previous_filter: {...deletePreviousFilters2}
                };
        case
        DELETE_ALL_PREVIOUS_SUBFILTERS_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case
        CLEAR_PREVIOUS_FILTER:
            return {
                ...state,
                previous_filter: {},
            };
        case
        CLEAR_FILTERS:
            return {
                ...state,
                active_filter: [],
            };
        case
        DELETE_FILTER:
            return {
                ...state,
                active_filter: state.active_filter.filter((x) => x !== action.payload)
            };
        case
        SET_START_DATE:
            return {
                ...state,
                start_date: action.payload
            };
        case
        SET_END_DATE:
            return {
                ...state,
                end_date: action.payload
            };
        case
        REFRESH_FILTERS:
            return {
                ...state,
                refresh_filter: !state.refresh_filter
            };
        case
        CLEAR_BASIC_FILTER:
            let name = Object.keys(action.payload)[0]
            let value = Object.values(action.payload)[0]
            let clearDFilters = state.previous_filter
            clearDFilters[name] = clearDFilters[name].filter(x => Object.keys(x)[0] != value);
            return {
                ...state,
                previous_filter: Object.assign({...state.previous_filter}, {[name]: state.previous_filter[name].filter(x => Object.keys(x)[0] != value)})
            };
        case
        GET_OPK_FILTERS:
            return {
                ...state,
                opk_filters: action.payload,
            };
        case
        GET_OPK_FILTERS_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
;
